export default __webpack_public_path__ + "static/media/dropdown-arrow-up.6a97383c.svg";